$(document).on('ready', function() {
  var urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('serviceterm')) {
    var tabSelect = urlParams.get('serviceterm');
    $('.tabs-title[data-slug="' + tabSelect + '"] a').click();
  }

  $('#anchor-top').on('click', function() {
    $('html, body')
      .stop()
      .animate({ scrollTop: 0 }, 500, 'swing');
  });

  // Home product categories slider
  var currCount = +$('.home__products-slider').data('count') / 2,
    currProdCount = Math.round(currCount);

  $('.home__products-slider')
    .on('afterChange init', function(event, slick) {
      slick.$slides.removeClass('hover-products-slide');

      slick.$slides.addClass('js-products-slide');
      // find current slide
      for (var i = 0; i < slick.$slides.length; i++) {
        var $slide = $(slick.$slides[i]);
        if ($slide.hasClass('slick-current')) {
          //$slide.prev().addClass('js-products-slide');
          $slide.addClass('hover-products-slide js-products-slide');
          //$slide.next().addClass('js-products-slide');
          break;
        }
      }
    })
    .on('beforeChange', function(event, slick) {
      slick.$slides.removeClass('hover-products-slide');
    })
    .slick({
      arrows: true,
      variableWidth: true,
      dots: true,
      infinite: false,
      centerMode: true,
      initialSlide: currProdCount - 1,
      adaptiveHeight: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            arrows: false,
          },
        },
        {
          breakpoint: 640,
          settings: {
            adaptiveHeight: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: false,
            centerMode: false,
            arrows: false,
          },
        },
      ],
    });

  $('.product-gallery__bottom').slick({
    variableWidth: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    rows: 0,
    infinite: false,
  });

  $('.home__products-slider .slick-current')
    .prev()
    .addClass('prev-products-slide');

  $('.home__products-slider .slick-current')
    .next()
    .addClass('next-products-slide');

  $('.js-products-slide').on('mouseover', function() {
    $('.home__products-slider .slick-slide').removeClass(
      'hover-products-slide'
    );
    $(this).addClass('hover-products-slide');
  });

  $('.careers-tabs .tabs-title a').click(function() {
    $('.careers-tabs .tabs-title a').attr('aria-selected', 'false');
    $(this).attr('aria-selected', 'true');
    $('html, body').animate(
      {
        scrollTop: $($(this).attr('href')).offset().top - 200,
      },
      500
    );
  });

  // $('.home__products-slider').on('click', '.slick-slide', function() {
  //   $('.home__products-slider .slick-slide').removeClass('active');
  //   $(this).addClass('active');
  // });

  $('.product-gallery__bottom .product-gallery__item').on('click', function() {
    $('.product-gallery__item').removeClass('active');
    $(this).addClass('active');
    var img = $(this)
      .children('img')
      .clone();
    $('.product-gallery__top .product-gallery__item').html(img);
  });

  $('.product-gallery__bottom .product-gallery__item.active').click();

  $('.home__industry-slider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '100px',
          infinite: false,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '0px',
          infinite: false,
        },
      },
    ],
  });

  $('.career-slider ').slick({
    slidesToShow: 1,
    variableWidth: true,
    centerMode: true,
    arrows: false,
    dots: false,
  });
});

$(document).bind('gform_post_render', function() {
  jQuery('.gfield').each(function() {
    var str;
    var startStr = jQuery(this)
      .find('input, textarea')
      .val();
    if (startStr) {
      jQuery(this)
        .find('label')
        .addClass('gfield_label-active');
      jQuery(this).addClass('gfield-active');
    }
    var gfield = jQuery(this);
    jQuery(this)
      .find('input, textarea')
      .on('input', function() {
        var input = jQuery(this);
        str = input.val();
        if (str) {
          gfield.addClass('gfield-active');
          gfield.find('label').addClass('gfield_label-active');
        } else {
          gfield.removeClass('gfield-active');
          gfield.find('label').removeClass('gfield_label-active');
        }
      });
  });
});
